import React from 'react';
import classnames from 'classnames';
import { LinearProgress } from '@mui/material';
import './ProcessDisplay.scss';

const styles = {
  progress: {
    height: 2,
    background: '#fff8',
  },
};

class ProcessDisplay extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      // last process description is read from the state to allow for a smooth
      // disappearing animation when the processes array becomes empty
      message: null,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.processes !== prevProps.processes && this.props.processes.length > 0) {
      this.setState({ message: this.props.processes[0].description });
    }
  }

  render() {
    const { processes, progress } = this.props;
    const { message } = this.state;
    const processesExist = processes.length > 0;
    const progressRequestType = processesExist && processes[0].progressRequestType;
    const processProgress = progressRequestType && progress[progressRequestType];

    return (
      <div
        className={classnames('process-display', {
          'is-expanded': processesExist,
        })}
      >
        <div>{message}</div>
        {processProgress && (
          <LinearProgress
            variant="determinate"
            style={styles.progress}
            value={processProgress.loaded}
            max={processProgress.total}
          />
        )}
      </div>
    );
  }
}

export default ProcessDisplay;
